import React, { useState } from 'react';
import EditAsset from './components/EditAsset';
import AssetsList from './components/AssetsList';
import { Col, Container, Row } from 'react-bootstrap';

const Assets = () => {
    const [listRequiresReload, setListRequiresReload] = useState(false);
    const [selectedAsset, setSelectedAsset] = useState();

    return (
        <Container>
            <Row>
                <Col md={12}>
                    <h3 className="page-title">Assets Management</h3>
                    <h3 className="page-subhead subhead">Manage workspace assets</h3>
                </Col>
            </Row>
            <Row>
                <Col md={12}>
                    <AssetsList setSelectedAsset={setSelectedAsset} setListRequiresReload={setListRequiresReload} listRequiresReload={listRequiresReload} />
                </Col>
            </Row>
            <Row>
                <Col md={12}>
                    {selectedAsset && <EditAsset setSelectedAsset={setSelectedAsset} setListRequiresReload={setListRequiresReload} selectedAsset={selectedAsset} />}
                </Col>
            </Row>
        </Container>
    );
};

export default Assets;